(function() {
    'use strict';
    /**
     * @memberof wbDashboard
     * @ngdoc Services
     * @name Notification
     * @description Notification service to handle notification data
     */
    angular.module('wbDashboard').factory('Notification', ['NotificationBase', function (NotificationBase) {
        var notification =  NotificationBase();


        if (notification.test) {
            notification.addModalActive({
                class: "modal-planning",
                ctaButton: "",
                description: "",
                id: "123-abc",
                // link: "modal:planning",
                link: "modal:something",
                messageType: "",
                name: "",
                read: false,
                manual: true,
                referrer_id: "",
                skipButton: "",
                type: "modal"
            });
        }

        return notification;
    }]);
})();
